/**
 * Configuracion de entorno en RUNTIME.
 *
 * Permite que el MISMO bundle compilado sirva distintos dominios segun el host,
 * sin recompilar. Cada contenedor genera su propio `env.js` (ver
 * `docker-entrypoint.web.sh`) que asigna `window.__env` con el dominio del host.
 *
 * Si `window.__env` no existe o esta vacio, cada `environment.*.ts` usa su valor
 * "horneado" por defecto (retrocompatible).
 */
export interface RuntimeEnv {
  API_URL?: string;
  WEB_URL?: string;
}

export function getRuntimeEnv(): RuntimeEnv {
  if (typeof window === 'undefined') {
    return {};
  }
  return (window as unknown as { __env?: RuntimeEnv }).__env || {};
}
